export default __webpack_public_path__ + "static/media/laboral_3.23e651d5.jpg";